import { memo } from "react";

type Props = {
	children: React.ReactNode;
};

export const BodyWrapper = memo(({ children }: Props) => {
	return <div className="flex max-w-full rounded-lg border border-zinc-100 bg-white p-5 lg:p-8">{children}</div>;
});

BodyWrapper.displayName = "BodyWrapper";
